module.exports = __webpack_public_path__ + "static/media/icon-pensionfund.887a471c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/WizardInvitee/parts/images/icon-pensionfund.svg
// module id = 568
// module chunks = 0